module.exports = __webpack_public_path__ + "static/media/hall-AH.60f75e6e.svg";